module.exports = __webpack_public_path__ + "322387152b03dc6f69c4dbc9fa4e7769.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-19.png
// module id = 1701
// module chunks = 0